export default __webpack_public_path__ + "de35ed89a07440d8b8ffa36f745569dd.png";